"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  CursorDouble: ['cursor-double', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.748,10.892,10.064,4.153a1.467,1.467,0,0,0-1.711.261A1,1,0,0,0,9.4,6.063l11.065,5.878a.25.25,0,0,1-.006.444l-2.44,1.223a1.008,1.008,0,0,0-.462.481L16.32,16.8a.25.25,0,0,1-.45.012l-.536-1.037a1,1,0,0,0-1.777.918l1.283,2.48a1.458,1.458,0,0,0,2.625-.061l1.762-3.872L22.7,13.5a1.458,1.458,0,0,0,.051-2.606Z', 'M16.206,12.224a1,1,0,0,0-.532-.895L1.942,4.033A1,1,0,0,0,.584,5.375l7.3,14.163a1,1,0,0,0,1.8-.044h0l2-4.4,3.974-1.987A1,1,0,0,0,16.206,12.224Z']],
  CursorAdd: ['cursor-add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.865,7.23a1.5,1.5,0,0,0,.307-2.8L2.723.708A1.5,1.5,0,0,0,.71,2.721l3.726,7.45a1.5,1.5,0,0,0,2.8-.309h0l.525-2.1Z', 'M15.448,7.446a8,8,0,1,0,8,8A8,8,0,0,0,15.448,7.446Zm3,9H16.7a.25.25,0,0,0-.25.25v1.75a1,1,0,1,1-2,0V16.7a.25.25,0,0,0-.25-.25h-1.75a1,1,0,0,1,0-2H14.2a.25.25,0,0,0,.25-.25v-1.75a1,1,0,1,1,2,0V14.2a.25.25,0,0,0,.25.25h1.75a1,1,0,0,1,0,2Z']],
  CursorSelect2: ['cursor-select-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.5,0H1A1,1,0,0,0,0,1V4.5a1,1,0,0,0,2,0V2.248A.25.25,0,0,1,2.25,2H4.5a1,1,0,0,0,0-2Z', 'M1,12.5a1,1,0,0,0,1-1v-3a1,1,0,0,0-2,0v3A1,1,0,0,0,1,12.5Z', 'M4.5,18H2.25a.25.25,0,0,1-.25-.25V15.5a1,1,0,1,0-2,0V19a1,1,0,0,0,1,1H4.5a1,1,0,0,0,0-2Z', 'M11.5,0h-3a1,1,0,0,0,0,2h3a1,1,0,0,0,0-2Z', 'M15.5,2h2.25a.25.25,0,0,1,.25.25V4.5a1,1,0,1,0,2,0V1a1,1,0,0,0-1-1H15.5a1,1,0,0,0,0,2Z', 'M19,7.5a1,1,0,0,0-1,1v3a1,1,0,0,0,2,0v-3A1,1,0,0,0,19,7.5Z', 'M11.5,18h-3a1,1,0,0,0,0,2h3a1,1,0,0,0,0-2Z', 'M23.43,18.075,15.5,14.107a1.033,1.033,0,0,0-1.386,1.385l3.969,7.937A1.033,1.033,0,0,0,20,23.216h0l.605-2.425a.251.251,0,0,1,.182-.182L23.218,20a1.033,1.033,0,0,0,.212-1.926Z']],
  CursorSelectCircle: ['cursor-select-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.000 11.998 A4.000 4.000 0 1 0 16.000 11.998 A4.000 4.000 0 1 0 8.000 11.998 Z', 'M21.345,8.438a1.012,1.012,0,0,0,1.29.578,1,1,0,0,0,.579-1.29,12.041,12.041,0,0,0-.888-1.841A1,1,0,0,0,20.605,6.9,9.935,9.935,0,0,1,21.345,8.438Z', 'M19.575,2.691a12.075,12.075,0,0,0-1.688-1.15,1,1,0,1,0-.981,1.743,10.09,10.09,0,0,1,1.407.959,1,1,0,0,0,1.262-1.552Z', 'M11.88,2h.011a9.825,9.825,0,0,1,1.7.126A1,1,0,0,0,13.908.15,12.129,12.129,0,0,0,11.87,0a1,1,0,0,0,.01,2Z', 'M6.907,3.392A9.97,9.97,0,0,1,8.44,2.653,1,1,0,1,0,7.728.784a12,12,0,0,0-1.841.888,1,1,0,1,0,1.02,1.72Z', 'M1.924,7.472a1,1,0,0,0,1.362-.379,9.983,9.983,0,0,1,.959-1.408A1,1,0,1,0,2.694,4.423,11.965,11.965,0,0,0,1.543,6.111,1,1,0,0,0,1.924,7.472Z', 'M1.011,13.117A1,1,0,0,0,2,12.106a10.074,10.074,0,0,1,.127-1.7,1,1,0,0,0-1.975-.317A12.1,12.1,0,0,0,0,12.128a1,1,0,0,0,1,.989Z', 'M2.655,15.557a1,1,0,0,0-1.869.712,12,12,0,0,0,.888,1.841A1,1,0,1,0,3.4,17.092,9.945,9.945,0,0,1,2.655,15.557Z', 'M7.094,20.712a10.177,10.177,0,0,1-1.407-.959A1,1,0,1,0,4.425,21.3a12.082,12.082,0,0,0,1.688,1.151,1,1,0,1,0,.981-1.743Z', 'M12.12,22h-.011a9.748,9.748,0,0,1-1.7-.126,1,1,0,1,0-.319,1.974A11.984,11.984,0,0,0,12,24a1,1,0,1,0,.117-2Z', 'M17.093,20.6a10.068,10.068,0,0,1-1.533.74,1,1,0,0,0-.579,1.291,1.014,1.014,0,0,0,1.291.578,12,12,0,0,0,1.841-.888,1,1,0,0,0-1.02-1.721Z', 'M22.076,16.523a1,1,0,0,0-1.362.38,9.973,9.973,0,0,1-.959,1.407,1,1,0,1,0,1.551,1.263,12.023,12.023,0,0,0,1.151-1.688A1,1,0,0,0,22.076,16.523Z', 'M22.989,10.879A1,1,0,0,0,22,11.889a10.078,10.078,0,0,1-.127,1.7,1,1,0,0,0,1.975.317A12.1,12.1,0,0,0,24,11.868,1.01,1.01,0,0,0,22.989,10.879Z']],
  CursorSelect1: ['cursor-select_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.5,0H2A2,2,0,0,0,0,2V3.5a1,1,0,0,0,2,0V2.248A.25.25,0,0,1,2.25,2H3.5a1,1,0,0,0,0-2Z', 'M1,10.5a1,1,0,0,0,1-1v-2a1,1,0,0,0-2,0v2A1,1,0,0,0,1,10.5Z', 'M3.5,15H2.25a.25.25,0,0,1-.25-.25V13.5a1,1,0,0,0-2,0V15a2,2,0,0,0,2,2H3.5a1,1,0,0,0,0-2Z', 'M9.5,0h-2a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z', 'M14.75,2a.25.25,0,0,1,.25.25V3.5a1,1,0,1,0,2,0V2a2,2,0,0,0-2-2H13.5a1,1,0,0,0,0,2Z', 'M16,6.5a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0v-2A1,1,0,0,0,16,6.5Z', 'M9.5,15h-2a1,1,0,1,0,0,2h2a1,1,0,0,0,0-2Z', 'M23.634,23.632a1.251,1.251,0,0,0,0-1.768l-4.015-4.015.984-.421a1,1,0,0,0-.014-1.844l-6.29-2.59a1,1,0,0,0-1.3,1.306l2.59,6.289h0a1,1,0,0,0,.918.618h.006a1,1,0,0,0,.92-.607l.422-.985,4.015,4.016A1.251,1.251,0,0,0,23.634,23.632Z']],
  CursorSelect3: ['cursor-select-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3,.013H1a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0v-.75a.25.25,0,0,1,.25-.25H3a1,1,0,1,0,0-2Z', 'M19,2.013h.75a.25.25,0,0,1,.25.25v.75a1,1,0,0,0,2,0v-2a1,1,0,0,0-1-1H19a1,1,0,0,0,0,2Z', 'M9,.013H7a1,1,0,0,0,0,2H9a1,1,0,0,0,0-2Z', 'M15,2.013a1,1,0,1,0,0-2H13a1,1,0,0,0,0,2Z', 'M3,20.013H2.25a.25.25,0,0,1-.25-.25v-.75a1,1,0,0,0-2,0v2a1,1,0,0,0,1,1H3a1,1,0,0,0,0-2Z', 'M9,20.013H7a1,1,0,0,0,0,2H9a1,1,0,0,0,0-2Z', 'M1,10.013a1,1,0,0,0,1-1v-2a1,1,0,0,0-2,0v2A1,1,0,0,0,1,10.013Z', 'M1,16.013a1,1,0,0,0,1-1v-2a1,1,0,0,0-2,0v2A1,1,0,0,0,1,16.013Z', 'M21,6.013a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0v-2A1,1,0,0,0,21,6.013Z', 'M23.488,16.092,13.11,12.2a.716.716,0,0,0-.808.128.724.724,0,0,0-.125.809l3.931,10.337a.671.671,0,0,0,.625.508h.035c.136-.009.466-.083.59-.586h0L18.5,18.708a.252.252,0,0,1,.183-.183l4.732-1.183c.5-.125.575-.457.583-.593A.66.66,0,0,0,23.488,16.092Z']],
  CursorTarget2: ['cursor-target-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.500 11.998 A2.500 2.500 0 1 0 14.500 11.998 A2.500 2.500 0 1 0 9.500 11.998 Z', 'M12,7.5A1.5,1.5,0,0,0,13.5,6V1.5a1.5,1.5,0,1,0-3,0V6A1.5,1.5,0,0,0,12,7.5Z', 'M22.5,10.5H18a1.5,1.5,0,0,0,0,3h4.5a1.5,1.5,0,0,0,0-3Z', 'M12,16.5A1.5,1.5,0,0,0,10.5,18v4.5a1.5,1.5,0,1,0,3,0V18A1.5,1.5,0,0,0,12,16.5Z', 'M6,10.5H1.5a1.5,1.5,0,0,0,0,3H6a1.5,1.5,0,0,0,0-3Z']],
  HandExpand: ['hand-expand', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.313,10.572a2,2,0,1,0-3.429-2.053l-.859,1.747a.25.25,0,0,1-.467-.17l1.476-5.962A2,2,0,1,0,15.123,3.3l-.732,3.745A.25.25,0,0,1,13.9,7V2.248a2,2,0,0,0-4,0V7.765a.25.25,0,0,1-.492.062l-1.019-4a2,2,0,1,0-3.907.858l2.25,8.966a.25.25,0,0,1-.422.235L4.747,12.273a2,2,0,0,0-2.763,2.882l5.3,7.045A5.026,5.026,0,0,0,10.9,23.748h3.5c3.316,0,5-2.236,5-6.649a4.92,4.92,0,0,1,.573-2.3Z']],
  HandDrag: ['hand-drag', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,5.248a1.473,1.473,0,0,0-.61.121.249.249,0,0,0-.15.229v5.02a.5.5,0,0,1-1,0V4.882A1.749,1.749,0,0,0,15.5,3.248a1.473,1.473,0,0,0-.61.121.249.249,0,0,0-.15.229v6.52a.5.5,0,0,1-1,0V3.882A1.749,1.749,0,0,0,12,2.248a1.473,1.473,0,0,0-.61.121.249.249,0,0,0-.15.229v7.02a.5.5,0,0,1-1,0V4.882A1.747,1.747,0,0,0,6.75,5l-.01,9.479a.5.5,0,0,1-1,0V10a.25.25,0,0,0-.25-.25H5A1.752,1.752,0,0,0,3.25,11.5v4c0,2.112,3.128,6.25,6.91,6.25H15.5a5.256,5.256,0,0,0,5.25-5.25V7A1.752,1.752,0,0,0,19,5.248Z']],
  TouchpadFinger: ['touchpad-finger', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.115,17H14.5a.249.249,0,0,1-.25-.25V10.373a2.375,2.375,0,0,0-4.75,0V18.9a.251.251,0,0,1-.455.145L8.022,17.6a2.117,2.117,0,0,0-2.662-.659,2.075,2.075,0,0,0-1.026,2.423,44.186,44.186,0,0,0,2.257,4.373A.5.5,0,0,0,7.032,24H21.254a.5.5,0,0,0,.5-.5V21.845l0-.014A4.811,4.811,0,0,0,17.115,17Z', 'M5.25,11a1,1,0,0,1-1-1V3a1,1,0,0,1,1-1h13.5a1,1,0,0,1,1,1v7a1,1,0,0,1-1,1H16a.249.249,0,0,0-.25.25v1.5A.249.249,0,0,0,16,13h2.75a3,3,0,0,0,3-3V3a3,3,0,0,0-3-3H5.25a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3h2.5a.25.25,0,0,0,.25-.25v-1.5A.25.25,0,0,0,7.75,11Z']],
  CursorType: ['cursor-type', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.75,18.248a1,1,0,0,0-1,1V21.5a.25.25,0,0,1-.25.25H19.25a1,1,0,0,0,0,2h3.5a1,1,0,0,0,1-1v-3.5A1,1,0,0,0,22.75,18.248Z', 'M22.75,11.248a1,1,0,0,0-1,1v3a1,1,0,0,0,2,0v-3A1,1,0,0,0,22.75,11.248Z', 'M22.75,3.748h-3.5a1,1,0,0,0,0,2H21.5a.25.25,0,0,1,.25.25v2.25a1,1,0,0,0,2,0v-3.5A1,1,0,0,0,22.75,3.748Z', 'M15.25,21.748h-3a1,1,0,0,0,0,2h3a1,1,0,1,0,0-2Z', 'M8.25,21.748H6a.25.25,0,0,1-.25-.25v-2.25a1,1,0,0,0-2,0v3.5a1,1,0,0,0,1,1h3.5a1,1,0,0,0,0-2Z', 'M4.75,16.248a1,1,0,0,0,1-1v-3a1,1,0,1,0-2,0v3A1,1,0,0,0,4.75,16.248Z', 'M12.25,5.748h3a1,1,0,0,0,0-2h-3a1,1,0,0,0,0,2Z', 'M9.146,4.078,1.7.353A1,1,0,0,0,.355,1.7L4.081,9.144a1,1,0,0,0,1.865-.2v0l.561-2.249a.248.248,0,0,1,.182-.182l2.252-.564a1,1,0,0,0,.205-1.865Z', 'M19.25,20.248a1,1,0,0,0,0-2,1.5,1.5,0,0,1-1.5-1.5v-1.5h1a1,1,0,0,0,0-2h-1v-2.5a1.5,1.5,0,0,1,1.5-1.5,1,1,0,1,0,0-2,3.482,3.482,0,0,0-2.5,1.059,3.482,3.482,0,0,0-2.5-1.059,1,1,0,1,0,0,2,1.5,1.5,0,0,1,1.5,1.5v2.5h-1a1,1,0,0,0,0,2h1v1.5a1.5,1.5,0,0,1-1.5,1.5,1,1,0,0,0,0,2,3.482,3.482,0,0,0,2.5-1.059A3.482,3.482,0,0,0,19.25,20.248Z']],
  CursorHand2Alternate: ['cursor-hand-2-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.363,5.238a2.5,2.5,0,0,0-.5.051V4.738A2.484,2.484,0,0,0,15.819,2.3a2.493,2.493,0,0,0-4.912,0A2.484,2.484,0,0,0,7.863,4.738v8.437l-1.213-1.7A2.485,2.485,0,0,0,2.6,14.352l5.467,7.716a4,4,0,0,0,3.264,1.689h.008l5.536-.011a5.008,5.008,0,0,0,4.99-5V7.738A2.5,2.5,0,0,0,19.363,5.238Zm.5,13.508a3,3,0,0,1-2.994,3l-5.536.011A2.03,2.03,0,0,1,9.7,20.913L4.23,13.2a.485.485,0,0,1,.791-.562L7.142,15.61a1.5,1.5,0,0,0,2.721-.872v-10a.5.5,0,1,1,1,0v6a1,1,0,0,0,2,0v-8a.5.5,0,1,1,1,0v8a1,1,0,0,0,2,0v-6a.5.5,0,1,1,1,0v7.5a1,1,0,0,0,2,0v-4.5a.5.5,0,1,1,1,0Z']],
  CursorHandAlternate: ['cursor-hand-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18,9H17.23A2,2,0,0,0,15.5,8H14.23A2,2,0,0,0,12.5,7h-1V2.5a2.5,2.5,0,0,0-5,0V10.14A4,4,0,0,0,3.5,14v2.842a5.03,5.03,0,0,0,1.465,3.536L7,22.412V23a1,1,0,0,0,2,0V22a1,1,0,0,0-.293-.707L6.378,18.963A3.023,3.023,0,0,1,5.5,16.841V14a1.992,1.992,0,0,1,1-1.722V15a1,1,0,0,0,2,0V2.5a.5.5,0,1,1,1,0V11a1,1,0,0,0,2,0V9.248a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25V11a1,1,0,0,0,2,0v-.75a.25.25,0,0,1,.25-.25h.5a.25.25,0,0,1,.25.25V12a1,1,0,0,0,2,0v-.75a.25.25,0,0,1,.25-.25H18a.5.5,0,0,1,.5.5v3.1a9.05,9.05,0,0,1-.346,2.474l-1.616,5.653a1,1,0,1,0,1.923.549l1.616-5.653A11.055,11.055,0,0,0,20.5,14.6V11.5A2.5,2.5,0,0,0,18,9Z']],
  CursorInformationAlternate: ['cursor-information-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.959,4.538a9.5,9.5,0,1,0,9.5,9.5A9.511,9.511,0,0,0,9.959,4.538Zm0,17a7.5,7.5,0,1,1,7.5-7.5A7.509,7.509,0,0,1,9.959,21.538Z', 'M23.393.6a.5.5,0,0,0-.457-.136l-8.81,1.861a.5.5,0,0,0-.073.957,11.48,11.48,0,0,1,6.658,6.658.5.5,0,0,0,.957-.072l1.861-8.811A.5.5,0,0,0,23.393.6Z', 'M12.209,17.788h-.75a.25.25,0,0,1-.25-.25v-3.75a2,2,0,0,0-2-2h-1a1,1,0,0,0,0,2h.75a.249.249,0,0,1,.25.25v3.5a.249.249,0,0,1-.25.25h-.75a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z', 'M8.709 9.538 A1.500 1.500 0 1 0 11.709 9.538 A1.500 1.500 0 1 0 8.709 9.538 Z']],
  CursorAlternate: ['cursor-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.2,20.084l-4.447-4.447L10.014,18.2a1.5,1.5,0,0,1-2.676-.414l-3.81-12.7A1.25,1.25,0,0,1,5.085,3.526l12.7,3.811a1.5,1.5,0,0,1,.424,2.67l-.01.006-2.562,1.735L20.085,16.2a1.5,1.5,0,0,1,0,2.121l-1.768,1.768A1.5,1.5,0,0,1,16.2,20.084Zm-4.6-7.011a1,1,0,0,1,.707.293l4.773,4.773a.249.249,0,0,0,.353,0l.708-.707a.25.25,0,0,0,0-.353l-4.773-4.773a1,1,0,0,1,.146-1.536l2.253-1.525A.25.25,0,0,0,15.7,8.8L6.288,5.976a.247.247,0,0,0-.248.062.252.252,0,0,0-.063.249L8.8,15.7a.25.25,0,0,0,.447.069l1.525-2.253A1,1,0,0,1,11.6,13.073Z']],
  HandDrag1Alternate: ['hand-drag-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18,6a2.449,2.449,0,0,0-.891.172A2.49,2.49,0,0,0,15,5a2.449,2.449,0,0,0-.891.172,2.484,2.484,0,0,0-4.219,0A2.443,2.443,0,0,0,9,5,2.5,2.5,0,0,0,6.5,7.5V8H6a2.723,2.723,0,0,0-2.5,3v1c0,2.971,1.614,8,7.665,8H14.5a6.007,6.007,0,0,0,6-6V8.5A2.5,2.5,0,0,0,18,6Zm.5,8a4,4,0,0,1-4,4H11.164C5.658,18,5.5,12.612,5.5,12V11c0-.419.174-1,.5-1h.5v1a1,1,0,0,0,2,0V7.5a.5.5,0,1,1,1,0v1a1,1,0,0,0,2,0v-2a.5.5,0,1,1,1,0v2a1,1,0,0,0,2,0v-1a.5.5,0,1,1,1,0V10a1,1,0,0,0,2,0V8.5a.5.5,0,0,1,1,0Z']],
  HandDragAlternate: ['hand-drag-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18,4.748a2.492,2.492,0,0,0-.544.063A2.5,2.5,0,0,0,15,2.748a2.469,2.469,0,0,0-.891.171,2.486,2.486,0,0,0-4.219,0A2.464,2.464,0,0,0,9,2.748a2.5,2.5,0,0,0-2.5,2.5v3.5H6a2.5,2.5,0,0,0-2.5,2.5v4c0,2.636,3.582,7,7.665,7H14.5a6.008,6.008,0,0,0,6-6v-9A2.5,2.5,0,0,0,18,4.748Zm.5,11.5a4.005,4.005,0,0,1-4,4H11.164c-3.153,0-5.665-3.591-5.665-5v-4a.5.5,0,0,1,.5-.5h.5v3.5a1,1,0,0,0,2,0v-9a.5.5,0,1,1,1,0v5a1,1,0,0,0,2,0v-6a.5.5,0,1,1,1,0v6a1,1,0,0,0,2,0v-5a.5.5,0,1,1,1,0v6a1,1,0,0,0,2,0v-4a.5.5,0,0,1,1,0Z']],
  CirclePadFinger: ['circle-pad-finger', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.428,10.042a1,1,0,0,0,.387-1.36,4.5,4.5,0,1,1,7.962-.173,1,1,0,1,0,1.789.895,6.5,6.5,0,1,0-11.5.251A1.012,1.012,0,0,0,6.428,10.042Z', 'M16.129,17H13.5a.249.249,0,0,1-.25-.25V10.371a2.375,2.375,0,0,0-4.75,0V18.9a.25.25,0,0,1-.454.145L7.162,17.8A2.075,2.075,0,1,0,3.49,19.737l2.1,3.991A.5.5,0,0,0,6.033,24H20.25a.5.5,0,0,0,.5-.5V21.843A4.8,4.8,0,0,0,16.129,17Z']],
  Cursor1: ['cursor-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.662,9.286,2.1.8A1,1,0,0,0,.8,2.1L9.288,22.659a1,1,0,0,0,1.885-.108l2.491-8.718a.249.249,0,0,1,.172-.171l8.718-2.491a1,1,0,0,0,.108-1.885Z']],
  Cursor: ['cursor', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.644,16.813l-4.668-4.667a.249.249,0,0,1,.034-.382l3-2.08h0a1,1,0,0,0-.283-1.78L5.029,4.093a.751.751,0,0,0-.934.934l3.811,12.7a1,1,0,0,0,1.78.282l2.079-3a.25.25,0,0,1,.382-.035l4.668,4.668a1,1,0,0,0,1.414,0l1.415-1.415A1,1,0,0,0,19.644,16.813Z']],
  CursorDoubleClick2: ['cursor-double-click-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.642,6.011a5,5,0,0,1,5.21,3.773,1,1,0,1,0,1.94-.483A7,7,0,0,0,10.5,4.016,7.111,7.111,0,0,0,4.02,10.46a7.018,7.018,0,0,0,5.138,7.293,1,1,0,1,0,.526-1.93,5.015,5.015,0,0,1-3.67-5.213A5.075,5.075,0,0,1,10.642,6.011Z', 'M11,20a9,9,0,0,1-9-9.256A9.107,9.107,0,0,1,10.744,2,9,9,0,0,1,20,11a1,1,0,0,0,2,0A11,11,0,0,0,10.688,0,11.134,11.134,0,0,0,0,10.688,11,11,0,0,0,11,22a1,1,0,0,0,0-2Z', 'M23.509,16.431,11.856,10.239A.925.925,0,0,0,10.6,11.481L16.793,23.5a.931.931,0,0,0,.821.5h.024a.933.933,0,0,0,.818-.542l1.685-3.709,3.348-1.674a.923.923,0,0,0,.02-1.642Z']],
  CursorHand: ['cursor-hand', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.32,9.391a.25.25,0,0,0-.333.236v2.121a.5.5,0,1,1-1,0v-2.5a1.619,1.619,0,0,0-1.5-1h-.25a.25.25,0,0,0-.25.25v2.25a.5.5,0,0,1-1,0v-2.5a1.619,1.619,0,0,0-1.5-1h-.25a.25.25,0,0,0-.25.25v3.25a.5.5,0,0,1-1,0v-8a2,2,0,0,0-4,0l.026,13.594a.5.5,0,0,1-1,0V11.525a.249.249,0,0,0-.384-.211,3.483,3.483,0,0,0-1.616,2.934v2.843a4.53,4.53,0,0,0,1.319,3.181L7.058,22v.713a.5.5,0,0,0,.5.5l9.554.037a1,1,0,0,0,.961-.725l1.518-5.292a10.778,10.778,0,0,0,.4-2.883v-2.6A2.5,2.5,0,0,0,18.32,9.391Z']],
  CursorHand1: ['cursor-hand-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.7,9.141a.251.251,0,0,0-.334.236V11.5a.5.5,0,1,1-1,0V9a1.617,1.617,0,0,0-1.5-1h-.25a.25.25,0,0,0-.25.25V10.5a.5.5,0,1,1-1,0V8a1.617,1.617,0,0,0-1.5-1h-.25a.25.25,0,0,0-.25.25V10.5a.5.5,0,1,1-1,0V3a2,2,0,0,0-4,0l0,11.078a.25.25,0,0,1-.454.145L6.239,11.875a1.984,1.984,0,0,0-3.233,2.3l5.951,8.4A1,1,0,0,0,9.773,23h8.714a1,1,0,0,0,.962-.725l1.517-5.292a10.738,10.738,0,0,0,.4-2.883V11.5A2.5,2.5,0,0,0,19.7,9.141Z']],
  CursorHand2: ['cursor-hand-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.141,6.323a1.779,1.779,0,0,0-1.608-.243.251.251,0,0,0-.174.238v4.92a.5.5,0,0,1-1,0v-6.5a1.757,1.757,0,0,0-.718-1.415,1.78,1.78,0,0,0-1.608-.243.251.251,0,0,0-.174.238v6.42a.5.5,0,0,1-1,0v-7a1.752,1.752,0,0,0-1.75-1.75,1.622,1.622,0,0,0-.588.107.249.249,0,0,0-.162.233v8.41a.5.5,0,0,1-1,0v-5a1.75,1.75,0,1,0-3.5,0v10a.253.253,0,0,1-.183.243.246.246,0,0,1-.273-.1l-2.12-2.971a1.735,1.735,0,0,0-2.828,2.011l5.47,7.719a3.255,3.255,0,0,0,2.654,1.366l5.036,0a6.258,6.258,0,0,0,6.244-6.25V7.738A1.757,1.757,0,0,0,21.141,6.323Z']],
  CursorDoubleClick1: ['cursor-double-click-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.561.437a1.5,1.5,0,0,0-2.122,0L15.646,6.23a.249.249,0,0,1-.353,0L13.7,4.64a.5.5,0,0,0-.853.323l-.353,6.01a.5.5,0,0,0,.5.53c.019,0-.4.024,6.04-.355a.5.5,0,0,0,.324-.852L17.768,8.705a.251.251,0,0,1,0-.354l5.793-5.793A1.5,1.5,0,0,0,23.561.437Z', 'M19.487,14H17.246a.25.25,0,0,0-.25.241A7,7,0,1,1,9.759,7,.25.25,0,0,0,10,6.752V4.511a.5.5,0,0,0-.526-.5A10,10,0,1,0,19.986,14.524a.5.5,0,0,0-.5-.526Z', 'M5,14a5,5,0,0,0,9.993.263.25.25,0,0,0-.25-.263H12.216a.249.249,0,0,0-.248.222,1.99,1.99,0,1,1-2.19-2.19A.249.249,0,0,0,10,11.781V9.254a.25.25,0,0,0-.263-.249A5.006,5.006,0,0,0,5,14Z']],
  CursorSelectFrame: ['cursor-select-frame', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9,0H2A2,2,0,0,0,0,2V9a1,1,0,0,0,1,1H2A1,1,0,0,0,3,9V3.5A.5.5,0,0,1,3.5,3H9a1,1,0,0,0,1-1V1A1,1,0,0,0,9,0Z', 'M22,0H15a1,1,0,0,0-1,1V2a1,1,0,0,0,1,1h5.5a.5.5,0,0,1,.5.5V9a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1V2A2,2,0,0,0,22,0Z', 'M9,21H3.5a.5.5,0,0,1-.5-.5V15a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v7a2,2,0,0,0,2,2H9a1,1,0,0,0,1-1V22A1,1,0,0,0,9,21Z', 'M23,14H22a1,1,0,0,0-1,1v5.5a.5.5,0,0,1-.5.5H15a1,1,0,0,0-1,1v1a1,1,0,0,0,1,1h7a2,2,0,0,0,2-2V15A1,1,0,0,0,23,14Z']],
  CursorSelectFrame2: ['cursor-select-frame-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.5,1h-8A1.5,1.5,0,0,0,1,2.5v8a.5.5,0,0,0,.5.5H6.468a.994.994,0,0,0,.8-.4,1.008,1.008,0,0,0,.165-.875L6.75,7.316A.251.251,0,0,1,6.991,7H10a1,1,0,0,0,1-1V1.5A.5.5,0,0,0,10.5,1Z', 'M21.5,1h-8a.5.5,0,0,0-.5.5V6a1,1,0,0,0,1,1h3.009a.251.251,0,0,1,.241.318l-.682,2.412a1.011,1.011,0,0,0,.167.875,1,1,0,0,0,.8.395H22.5a.5.5,0,0,0,.5-.5v-8A1.5,1.5,0,0,0,21.5,1Z', 'M10,17H6.991a.251.251,0,0,1-.241-.318l.682-2.413a1.012,1.012,0,0,0-.167-.875.994.994,0,0,0-.8-.394H1.5a.5.5,0,0,0-.5.5v8A1.5,1.5,0,0,0,2.5,23h8a.5.5,0,0,0,.5-.5V18A1,1,0,0,0,10,17Z', 'M22.5,13H17.532a.993.993,0,0,0-.8.4,1.008,1.008,0,0,0-.165.875l.681,2.411a.251.251,0,0,1-.241.318H14a1,1,0,0,0-1,1v4.5a.5.5,0,0,0,.5.5h8A1.5,1.5,0,0,0,23,21.5v-8A.5.5,0,0,0,22.5,13Z']],
  CursorDoubleClick3: ['cursor-double-click-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.779,6.148A5,5,0,0,1,15.99,9.922a1,1,0,0,0,1.94-.484,6.993,6.993,0,0,0-7.289-5.285A7.111,7.111,0,0,0,4.158,10.6,7.018,7.018,0,0,0,9.3,17.89a1,1,0,0,0,.525-1.929,5.016,5.016,0,0,1-3.669-5.213A5.076,5.076,0,0,1,10.779,6.148Z', 'M10.241,20.092a9.029,9.029,0,0,1-8.1-9.212,9.106,9.106,0,0,1,8.741-8.741,9.028,9.028,0,0,1,9.212,8.1,1,1,0,0,0,1.99-.2A11.013,11.013,0,0,0,10.826.139,11.133,11.133,0,0,0,.142,10.824a11.036,11.036,0,0,0,9.9,11.258c.034,0,.067,0,.1,0a1,1,0,0,0,.1-2Z', 'M23.594,21.134,19.85,17.388a.249.249,0,0,1,.034-.382l2.352-1.628h0a.913.913,0,0,0-.257-1.625L11.487,10.605a.706.706,0,0,0-.88.879l3.147,10.492a.913.913,0,0,0,1.625.258l1.629-2.352a.25.25,0,0,1,.382-.035l3.745,3.746a.913.913,0,0,0,1.291,0l1.168-1.168A.911.911,0,0,0,23.594,21.134Z']],
  CursorInformation: ['cursor-information', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.71,5.288a9,9,0,1,0,9,9A9.01,9.01,0,0,0,9.71,5.288ZM11.784,19.08h-4a.75.75,0,1,1,0-1.5h1a.25.25,0,0,0,.25-.25v-4a.25.25,0,0,0-.25-.25h-1a.75.75,0,0,1,0-1.5h1a1.752,1.752,0,0,1,1.75,1.75v4a.25.25,0,0,0,.25.25h1a.75.75,0,0,1,0,1.5Zm-2-11.25a1.25,1.25,0,1,1-1.25,1.25A1.25,1.25,0,0,1,9.784,7.83Z', 'M23.144.854a.5.5,0,0,0-.457-.135l-8.811,1.86a.5.5,0,0,0-.072.957,11.48,11.48,0,0,1,6.658,6.658.5.5,0,0,0,.957-.072l1.86-8.811A.5.5,0,0,0,23.144.854Z']],
  CursorSelectHeart: ['cursor-select-heart', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.488,16.107,12.111,12.215a.7.7,0,0,0-.934.938l3.931,10.335a.668.668,0,0,0,.625.509h.034c.137-.008.468-.082.591-.586h0L17.5,18.723a.25.25,0,0,1,.182-.184l4.733-1.182c.5-.126.575-.458.583-.594A.658.658,0,0,0,22.488,16.107Z', 'M7.127,13.543a1,1,0,0,0-1.436,1.394L7.64,16.943A1,1,0,1,0,9.075,15.55Z', 'M7.511,2.1A1,1,0,0,0,7.923.139,6.7,6.7,0,0,0,4.668.271a1,1,0,1,0,.566,1.918A4.7,4.7,0,0,1,7.511,2.1Z', 'M2.02,6.054a4.4,4.4,0,0,1,.458-1.577A4.64,4.64,0,0,1,2.8,3.934,1,1,0,0,0,1.159,2.8,6.473,6.473,0,0,0,.03,5.866a1,1,0,0,0,1.99.188Z', 'M3.328,9.632a4.346,4.346,0,0,1-.569-.686A1,1,0,0,0,1.1,10.059a6.371,6.371,0,0,0,.811.982l1.185,1.221a1,1,0,0,0,1.435-1.394Z', 'M12,5a1,1,0,0,0,.674-.26l1.108-1.011a1,1,0,1,0-1.348-1.478l-.266.243a.25.25,0,0,1-.337,0l-.266-.243a1,1,0,1,0-1.347,1.478l1.108,1.011A1,1,0,0,0,12,5Z', 'M16.483,2.1a4.708,4.708,0,0,1,2.279.089A1,1,0,1,0,19.324.268,6.7,6.7,0,0,0,16.069.141,1,1,0,0,0,16.483,2.1Z', 'M23.97,5.855a6.44,6.44,0,0,0-.662-2.282,6.663,6.663,0,0,0-.47-.786A1,1,0,0,0,21.2,3.928a4.583,4.583,0,0,1,.327.548,4.392,4.392,0,0,1,.457,1.572,1,1,0,0,0,1.991-.193Z', 'M22.637,8.665a1,1,0,0,0-1.388.274,4.612,4.612,0,0,1-.591.709l-1.18,1.215a1,1,0,0,0,1.436,1.393l1.164-1.2a6.444,6.444,0,0,0,.831-1A1,1,0,0,0,22.637,8.665Z']],
  CursorSelect: ['cursor-select', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.162,13.628l-3.087-2.264a.707.707,0,0,0-1.127.568v1.014a.25.25,0,0,1-.25.25H15.2a.25.25,0,0,1-.25-.25v-3.5a.25.25,0,0,1,.25-.25h1.015a.7.7,0,0,0,.566-1.127L14.514,4.98a.732.732,0,0,0-1.133,0L11.119,8.066a.706.706,0,0,0,.565,1.13H12.7a.25.25,0,0,1,.25.25v3.5a.25.25,0,0,1-.25.25H9.2a.25.25,0,0,1-.25-.25V11.932a.705.705,0,0,0-1.125-.568L4.733,13.63a.706.706,0,0,0,0,1.135l3.087,2.263a.705.705,0,0,0,1.126-.567V15.446a.25.25,0,0,1,.25-.25h3.5a.25.25,0,0,1,.25.25v3.5a.25.25,0,0,1-.25.25H11.684a.706.706,0,0,0-.568,1.125l2.266,3.091a.706.706,0,0,0,1.134,0l2.263-3.086a.705.705,0,0,0-.566-1.127H15.2a.25.25,0,0,1-.25-.25v-3.5a.25.25,0,0,1,.25-.25h3.5a.25.25,0,0,1,.25.25v1.015a.706.706,0,0,0,1.126.567l3.09-2.265a.708.708,0,0,0,0-1.135Z', 'M5.386,9.742a1,1,0,0,0,.861-.752h0l.561-2.25a.251.251,0,0,1,.181-.182L9.243,6A1,1,0,0,0,9.448,4.13L2,.405A1,1,0,0,0,.657,1.747L4.383,9.2A1,1,0,0,0,5.386,9.742Z']],
  HandDrag1: ['hand-drag-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,6.5a1.473,1.473,0,0,0-.61.121.249.249,0,0,0-.15.229v2.52a.5.5,0,0,1-1,0V6.132A1.749,1.749,0,0,0,15.5,4.5a1.473,1.473,0,0,0-.61.121.249.249,0,0,0-.15.229v4.02a.5.5,0,0,1-1,0V5.132A1.749,1.749,0,0,0,12,3.5a1.473,1.473,0,0,0-.61.121.249.249,0,0,0-.15.229v4.52a.5.5,0,0,1-1,0V6.132a1.747,1.747,0,0,0-3.49.116l-.01,6.979a.5.5,0,0,1-1,0V8.748a.25.25,0,0,0-.25-.25H5a1.752,1.752,0,0,0-1.75,1.75v4c0,2.112,3.128,6.25,6.91,6.25H15.5a5.256,5.256,0,0,0,5.25-5.25v-7A1.752,1.752,0,0,0,19,6.5Z']],
  CursorAddAlternate: ['cursor-add-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6,8.99l.6-2.4,2.4-.6A1,1,0,0,0,9.2,4.13L1.749.405A1,1,0,0,0,.407,1.747L4.133,9.2A1,1,0,0,0,6,8.991Z', 'M17.7,13.7h-1.75a.25.25,0,0,1-.25-.25V11.7a1,1,0,1,0-2,0v1.75a.25.25,0,0,1-.25.25H11.7a1,1,0,0,0,0,2h1.75a.25.25,0,0,1,.25.25V17.7a1,1,0,1,0,2,0v-1.75a.25.25,0,0,1,.25-.25H17.7a1,1,0,0,0,0-2Z', 'M14.7,5.7a9,9,0,1,0,9,9A9.01,9.01,0,0,0,14.7,5.7Zm0,16a7,7,0,1,1,7-7A7.008,7.008,0,0,1,14.7,21.7Z']],
  Cursor1Alternate: ['cursor-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.654,22.676.382,2.648A1.737,1.737,0,0,1,2.651.38L22.677,8.651a1.737,1.737,0,0,1-.19,3.276l-8.211,2.346-2.348,8.215a1.736,1.736,0,0,1-3.274.188ZM3.95,3.621a.25.25,0,0,0-.327.326L9.852,19.029A.25.25,0,0,0,10.324,19l1.665-5.824a1.745,1.745,0,0,1,1.2-1.194l5.82-1.662a.25.25,0,0,0,.026-.472Z']],
  CursorSelect4: ['cursor-select-4', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.487,16.107,13.11,12.216a.7.7,0,0,0-.934.937l3.931,10.335a.67.67,0,0,0,.625.51l.035,0c.136-.008.467-.082.59-.585h0L18.5,18.723a.25.25,0,0,1,.183-.183l4.732-1.183c.5-.125.575-.457.583-.594A.658.658,0,0,0,23.487,16.107Z', 'M12,1a1,1,0,0,0-1-1A10.973,10.973,0,0,0,7.7.5,1,1,0,1,0,8.3,2.41,9,9,0,0,1,11,2,1,1,0,0,0,12,1Z', 'M4.636,4.634A1,1,0,0,0,3.222,3.22,11.015,11.015,0,0,0,1.245,5.909a1,1,0,1,0,1.772.926A9.008,9.008,0,0,1,4.636,4.634Z', 'M2,11a1,1,0,0,0-2,0,11,11,0,0,0,.5,3.3,1,1,0,0,0,1.908-.6A9,9,0,0,1,2,11Z', 'M6.837,18.98a8.971,8.971,0,0,1-2.2-1.618,1,1,0,1,0-1.414,1.415,11.009,11.009,0,0,0,2.689,1.976,1,1,0,1,0,.926-1.773Z', 'M11.943,19.949A9.172,9.172,0,0,1,11,20a1,1,0,0,0,0,2,11.177,11.177,0,0,0,1.15-.06,1,1,0,1,0-.207-1.989Z', 'M20,11a1,1,0,0,0,2,0,10.994,10.994,0,0,0-.5-3.3,1,1,0,0,0-1.908.6A9,9,0,0,1,20,11Z', 'M15.163,3.015a9,9,0,0,1,2.2,1.619,1,1,0,0,0,1.414-1.415,11.009,11.009,0,0,0-2.689-1.976,1,1,0,1,0-.926,1.772Z']],
  CursorTarget1: ['cursor-target-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,12a1.25,1.25,0,0,0-1.25-1.25H21.155a9.254,9.254,0,0,0-7.905-7.9V1.248a1.25,1.25,0,1,0-2.5,0v1.6a9.254,9.254,0,0,0-7.9,7.9H1.25a1.25,1.25,0,0,0,0,2.5h1.6a9.254,9.254,0,0,0,7.9,7.9v1.6a1.25,1.25,0,1,0,2.5,0v-1.6a9.254,9.254,0,0,0,7.905-7.9H22.75A1.25,1.25,0,0,0,24,12ZM13.558,18.561a.25.25,0,0,1-.308-.243v-1.07a1.25,1.25,0,1,0-2.5,0v1.07a.25.25,0,0,1-.308.243,6.764,6.764,0,0,1-5.006-5.005.25.25,0,0,1,.244-.308H6.75a1.25,1.25,0,0,0,0-2.5H5.68a.252.252,0,0,1-.2-.095.254.254,0,0,1-.047-.213,6.767,6.767,0,0,1,5.006-5.006.251.251,0,0,1,.213.048.248.248,0,0,1,.1.2v1.07a1.25,1.25,0,1,0,2.5,0V5.678a.251.251,0,0,1,.308-.244,6.767,6.767,0,0,1,5.006,5.006.254.254,0,0,1-.047.213.252.252,0,0,1-.2.095H17.25a1.25,1.25,0,0,0,0,2.5h1.07a.25.25,0,0,1,.244.308A6.764,6.764,0,0,1,13.558,18.561Z']],
  CursorQuestionAlternate: ['cursor-question-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.959,4.538a9.5,9.5,0,1,0,9.5,9.5A9.511,9.511,0,0,0,9.959,4.538Zm0,17a7.5,7.5,0,1,1,7.5-7.5A7.509,7.509,0,0,1,9.959,21.538Z', 'M23.393.6a.5.5,0,0,0-.457-.136l-8.81,1.861a.5.5,0,0,0-.073.957,11.48,11.48,0,0,1,6.658,6.658.5.5,0,0,0,.957-.072l1.861-8.811A.5.5,0,0,0,23.393.6Z', 'M8.459 19.038 A1.500 1.500 0 1 0 11.459 19.038 A1.500 1.500 0 1 0 8.459 19.038 Z', 'M9.959,8.038a3.589,3.589,0,0,0-3.585,3.586,1,1,0,0,0,2,0,1.586,1.586,0,1,1,2.22,1.454,2.725,2.725,0,0,0-1.635,2.5,1,1,0,0,0,2,0,.724.724,0,0,1,.436-.664A3.587,3.587,0,0,0,9.959,8.038Z']],
  TouchFinger1: ['touch-finger_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.129,17H14.5a.25.25,0,0,1-.25-.25V10.373a2.375,2.375,0,0,0-4.75,0V18.9a.25.25,0,0,1-.454.145l-.885-1.242a2.075,2.075,0,0,0-3.672,1.932l2.1,3.991A.5.5,0,0,0,7.032,24H21.25a.5.5,0,0,0,.5-.5V21.845A4.8,4.8,0,0,0,17.129,17Z', 'M11.75,5a1,1,0,0,0,1-1V1a1,1,0,1,0-2,0V4A1,1,0,0,0,11.75,5Z', 'M16.346,6.316l2.122-2.122A1,1,0,0,0,17.053,2.78L14.932,4.9a1,1,0,1,0,1.414,1.414Z', 'M16.25,9.5a1,1,0,0,0,1,1h3a1,1,0,0,0,0-2h-3A1,1,0,0,0,16.25,9.5Z', 'M7.154,6.316A1,1,0,0,0,8.568,4.9L6.447,2.78A1,1,0,0,0,5.033,4.194Z', 'M7.25,9.5a1,1,0,0,0-1-1h-3a1,1,0,0,0,0,2h3A1,1,0,0,0,7.25,9.5Z']],
  CursorHand1Alternate: ['cursor-hand-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.862,11.5a3,3,0,0,0-3-3h-.268a2,2,0,0,0-1.732-1H15.594a2,2,0,0,0-1.732-1h-1V3a2.5,2.5,0,0,0-5,0v10.3l-1.213-1.7A2.485,2.485,0,0,0,2.6,14.47l6.1,8.606a1,1,0,1,0,1.631-1.157l-6.095-8.6a.485.485,0,0,1,.791-.563l2.12,2.976a1.5,1.5,0,0,0,2.721-.871V3a.5.5,0,0,1,1,0v7.5a1,1,0,0,0,2,0V8.747a.25.25,0,0,1,.25-.25h.5a.249.249,0,0,1,.25.25V10.5a1,1,0,0,0,2,0v-.75a.25.25,0,0,1,.25-.25h.5a.249.249,0,0,1,.25.25V11.5a1,1,0,0,0,2,0V10.79a.251.251,0,0,1,.106-.2.248.248,0,0,1,.228-.031,1,1,0,0,1,.666.942v2.6a9.012,9.012,0,0,1-.346,2.474L17.9,22.223a1,1,0,0,0,1.923.549l1.616-5.654a11.042,11.042,0,0,0,.422-3.022Z']],
  CursorSelectFrame1: ['cursor-select-frame-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9,0H8A1,1,0,0,0,7,1v5.75A.25.25,0,0,1,6.75,7H1A1,1,0,0,0,0,8V9a1,1,0,0,0,1,1H8a2,2,0,0,0,2-2V1A1,1,0,0,0,9,0Z', 'M23,7H17.25a.25.25,0,0,1-.25-.25V1a1,1,0,0,0-1-1H15a1,1,0,0,0-1,1V8a2,2,0,0,0,2,2h7a1,1,0,0,0,1-1V8A1,1,0,0,0,23,7Z', 'M8,14H1a1,1,0,0,0-1,1v1a1,1,0,0,0,1,1H6.75a.25.25,0,0,1,.25.25V23a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1V16A2,2,0,0,0,8,14Z', 'M23,14H16a2,2,0,0,0-2,2v7a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1v-5.75a.25.25,0,0,1,.25-.25H23a1,1,0,0,0,1-1V15A1,1,0,0,0,23,14Z']],
  CursorSelectCircle1: ['cursor-select-circle-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.001 11.998 A3.999 3.999 0 1 0 15.999 11.998 A3.999 3.999 0 1 0 8.001 11.998 Z', 'M22.018,7.352a1,1,0,0,0,.364-1.367,12.088,12.088,0,0,0-4.367-4.374,1,1,0,0,0-1.007,1.728,10.093,10.093,0,0,1,3.644,3.649A1,1,0,0,0,22.018,7.352Z', 'M7.007,3.33A10.087,10.087,0,0,1,11.988,2a1,1,0,0,0,0-2h0a12.082,12.082,0,0,0-5.97,1.6A1,1,0,0,0,7.007,3.33Z', 'M2,11.989A10.1,10.1,0,0,1,3.337,7.008a1,1,0,1,0-1.733-1A12.1,12.1,0,0,0,0,11.98a1,1,0,0,0,1,1H1A1,1,0,0,0,2,11.989Z', 'M6.992,20.657a10.093,10.093,0,0,1-3.644-3.649,1,1,0,1,0-1.73,1,12.1,12.1,0,0,0,4.367,4.374,1,1,0,0,0,1.007-1.728Z', 'M16.993,20.666A10.087,10.087,0,0,1,12.012,22a1,1,0,0,0,0,2h0a12.082,12.082,0,0,0,5.97-1.6,1,1,0,0,0-.991-1.736Z', 'M23.005,11.012h0a1,1,0,0,0-1,.995,10.1,10.1,0,0,1-1.338,4.981,1,1,0,0,0,1.733,1A12.1,12.1,0,0,0,24,12.015,1,1,0,0,0,23.005,11.012Z']],
  CursorQuestion: ['cursor-question', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.71,5.288a9,9,0,1,0,9,9A9.01,9.01,0,0,0,9.71,5.288ZM9.624,19.576a1,1,0,1,1,1-1A1,1,0,0,1,9.624,19.576Zm1.335-4.643a.973.973,0,0,0-.585.892.75.75,0,0,1-1.5,0,2.474,2.474,0,0,1,1.484-2.267,1.836,1.836,0,1,0-2.57-1.684.75.75,0,0,1-1.5,0,3.336,3.336,0,1,1,4.671,3.059Z', 'M23.144.854a.5.5,0,0,0-.457-.135l-8.811,1.86a.5.5,0,0,0-.072.957,11.48,11.48,0,0,1,6.658,6.658.5.5,0,0,0,.957-.072l1.86-8.811A.5.5,0,0,0,23.144.854Z']],
  CursorTarget: ['cursor-target', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,11H20.941A9.014,9.014,0,0,0,13,3.056V1a1,1,0,1,0-2,0V3.056A9.014,9.014,0,0,0,3.059,11H1a1,1,0,0,0,0,2H3.059A9.013,9.013,0,0,0,11,20.939V23a1,1,0,1,0,2,0V20.939A9.013,9.013,0,0,0,20.941,13H23a1,1,0,0,0,0-2Zm-4.129-.3a.251.251,0,0,1-.246.3H16.574a.249.249,0,0,1-.241-.184,4.506,4.506,0,0,0-3.149-3.149A.251.251,0,0,1,13,7.424V5.373a.251.251,0,0,1,.3-.246A7.008,7.008,0,0,1,18.871,10.7ZM12,14.5A2.5,2.5,0,1,1,14.5,12,2.5,2.5,0,0,1,12,14.5ZM10.7,5.127a.251.251,0,0,1,.3.246V7.424a.249.249,0,0,1-.184.241,4.506,4.506,0,0,0-3.149,3.149A.251.251,0,0,1,7.426,11H5.375a.251.251,0,0,1-.246-.3A7.008,7.008,0,0,1,10.7,5.127ZM5.129,13.294a.25.25,0,0,1,.246-.3H7.426a.249.249,0,0,1,.241.184,4.506,4.506,0,0,0,3.149,3.149.25.25,0,0,1,.184.241v2.051a.247.247,0,0,1-.091.192.251.251,0,0,1-.206.054A7.008,7.008,0,0,1,5.129,13.294ZM13.3,18.869a.251.251,0,0,1-.206-.054A.247.247,0,0,1,13,18.623V16.572a.249.249,0,0,1,.184-.241,4.506,4.506,0,0,0,3.149-3.149A.249.249,0,0,1,16.574,13h2.051a.249.249,0,0,1,.246.3A7.008,7.008,0,0,1,13.3,18.869Z']],
  CursorDoubleClick: ['cursor-double-click', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.757,13.728H17.516a.25.25,0,0,0-.25.241,7,7,0,1,1-7.237-7.237.25.25,0,0,0,.241-.25V4.241a.5.5,0,0,0-.526-.5A10,10,0,1,0,20.256,14.254.5.5,0,0,0,19.757,13.728Z', 'M5.27,13.728a5,5,0,0,0,9.993.263.25.25,0,0,0-.249-.263H12.486a.25.25,0,0,0-.248.222,1.99,1.99,0,1,1-2.19-2.19.249.249,0,0,0,.222-.249V8.984a.25.25,0,0,0-.263-.249A5.006,5.006,0,0,0,5.27,13.728Z', 'M23.583,3.243,20.755.414a.5.5,0,0,0-.707,0l-1.46,1.46a.5.5,0,0,0,0,.707L21.417,5.41a.5.5,0,0,0,.707,0l1.459-1.46A.5.5,0,0,0,23.583,3.243Z', 'M17.8,3.374a.5.5,0,0,0-.707,0L14.214,6.247a.249.249,0,0,1-.353,0L12.624,5.01a.5.5,0,0,0-.854.354v6.364a.5.5,0,0,0,.5.5h6.364a.5.5,0,0,0,.353-.854L17.75,10.137a.249.249,0,0,1,0-.353L20.624,6.91a.5.5,0,0,0,0-.708Z']]
};
exports["default"] = _default;